import { LogoLoader } from '@/components/logo-loader';
import type { ConnectionPhase } from '@/entities/connection-entity';
import { cn } from '@/lib/utils';

const STATUS_MESSAGES: Record<Exclude<ConnectionPhase, 'online'>, string> = {
	updating: 'Сейчас начнётся обновление',
	reconnecting: 'Подождите, восстанавливаем соединение с сервером',
	unavailable: 'Сервер недоступен, возможно идёт обновление',
};

type ServerStatusOverlayProps = {
	phase: Exclude<ConnectionPhase, 'online'>;
	className?: string;
};

export function ServerStatusOverlay({ phase, className }: ServerStatusOverlayProps) {
	return (
		<div
			className={cn(
				'fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-background px-6 text-center',
				className,
			)}
			role='status'
			aria-live='polite'
			aria-label={STATUS_MESSAGES[phase]}
		>
			<LogoLoader />
			<p className='text-sm text-muted-foreground'>{STATUS_MESSAGES[phase]}</p>
		</div>
	);
}
